import './parental-control.scss';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
	getPgList, getProfile,
	sendCodeAgeRating,
	setRatingCode,
	validationCodeAgeRating,
} from '../../../../shared/services/user/user-service';
import Loading from '../../../../components/loading/item-loading/loading';
import Box from '@material-ui/core/Box';
import Dialog from '@material-ui/core/Dialog';
import OTPInput from '../../../../components/otp/otp-input';
import Countdown from '../../../../components/countdown/countdown';
import { ShowToast, toastTypes } from '../../../../components/toast/show-tosat';
import Toast from '../../../../components/toast/toast';
import { useHistory  } from 'react-router-dom';
import profileActions from '../../../../store/actions/profile.action';


function ParentalControlProfilePage() {
	const { profile }                                 = useSelector(state => state.profileData);
	const [isLoad, setIsLoad] = useState(false);
	const [isSetParentalControl, setIsSetParentalControl] = useState(false);
	const [pgList, setPgList] = useState([]);
	const [selectedOption, setSelectedOption] = useState(5);
	const [optDialog, setOptDialog] = useState(false);
	const [error, setError] = useState(null);
	const [message, setMessage] = useState(null);
	const [toastData, setToastData] = useState([]);
	const dispatch = useDispatch();

	const history = useHistory();

	useEffect(() => {
		pgListApi();
	}, []);
	useEffect(() => {
		getParentalControlCode();
	}, [profile]);


	const pgListApi = () => {
		getPgList().then((result) => {
			if (result.status === 200 && result.data.code === 200) {
				setPgList(result.data.data);
				setIsLoad(true);
				getParentalControlCode()
			}
		});
	};

	const getParentalControlCode = () => {
		if (profile && profile?.parentalControlCode) {
			setSelectedOption(profile.parentalControlCode)
			setIsSetParentalControl(true)
		}
	}

	const ageRatingApi = () => {
		if (!selectedOption) return
		setRatingCode(selectedOption).then(
			(result) => {
				if (result.status === 200 && result.data.code === 200) {
					setIsLoad(true)
				}
			}
		);
	}

	const sendCode = () => {
		if (!selectedOption) return
		sendCodeAgeRating().then(
			(result) => {
				if (result.status === 200 && result.data.code === 200) {
					setToastData(ShowToast(toastTypes.success, 'تنظیمات کنترل والدین بروزرسانی شد'));
					setError(null)
				}
			}
		).catch(
			(error) => {
				let response = error.response.data;
				setError(response.message)
				setMessage(null)
				setTimeout(()=> {
					setError(null)
				}, 6000)
			}
		);
	}

	const handleClose = () => {
		setOptDialog(false);
	};

	const checkParentalControl = () => {
		if (isSetParentalControl) {
			handleOpen()
		} else {
			ageRatingApi()
		}
	}

	const handleOpen = () => {
		setOptDialog(true);
		sendCode()
	};

	const callProfile = () => {
		getProfile().then(
			(result) => {
				if (result.status === 200 && result.data.code === 200) {
					dispatch(profileActions(result.data.data));
				}
			}
		).catch(
			(error) => {
				console.log(error);
			}
		);
	}

	const handleOtpComplete = (otpValue) => {
		validationCodeAgeRating(otpValue, selectedOption).then(
			(result) => {
				if (result.status === 200 && result.data.code === 200) {
					setToastData(ShowToast(toastTypes.success, 'تنظیمات کنترل والدین بروزرسانی شد'));
					callProfile()
					setError(null)
					setTimeout(()=> {
						handleClose()
						history.push('/');
					}, 500)
				}
			}
		).catch(
			(error) => {
				let response = error.response.data;
				setError(response.message)
				setMessage(null)
				setTimeout(()=> {
					setError(null)
				}, 6000)
			}
		);
	};

	if (!isLoad) return <Loading />;

	return (
		<div className="pg-warp">
			<Box className="pg-profile-bg" />
			<Box className="pg-profile-container">
				<div className="radio-container w-100">
					<h3 className="radio-title">کنترل والدین</h3>
					<div className="pg-list">
						{pgList.map((option) => (
							<div
								key={option.code}
								className={`radio-option ${selectedOption === option.code ? "selected" : ""}`}
								onClick={() => setSelectedOption(option.code)}
							>
								<span className="radio-text">{option.title}</span>
							</div>
						))}
					</div>
					<div className="w-100">
						<button className="radio-button" onClick={checkParentalControl}>
							<span className="radio-button-text">ثبت</span>
						</button>
					</div>
				</div>
			</Box>

			<Dialog
				onClose={handleClose}
				open={optDialog}
				classes={{
					root: 'opt-age-rating-dialog',
					paper: 'opt-age-rating-dialog-paper'
				}}
			>
				<div className='message'>
					<span>کد ارسال شده به شماره همراه را وارد کنید</span>
				</div>
				<OTPInput length={5} onComplete={handleOtpComplete} />

				{error &&
					<p style={{ color: 'red', fontSize: '12px', marginTop: '8px', direction: 'rtl', }}>{error}</p>}
				{message && <p style={{
					color: '#fff',
					fontSize: '12px',
					marginTop: '8px',
					direction: 'rtl',
					width: '100%',
					maxWidth: '281px'
				}}>{message}</p>}
				<div className='countdown'>
					<Countdown initialTime={120}
							   resetFunc={sendCode} />
				</div>
			</Dialog>
			<Toast toastList={toastData}
				   position={'top-right'}
				   autoDelete={true}
				   dismissTime={5000} />
		</div>
	);
}

export default ParentalControlProfilePage;
